import { BaseTag }   from "mixs/base/base_mixin";
import moment from 'moment';
import { Global, LineCalendarCell, LineSelectedCell } from 'mixs/orders/planner/model';
export class GenCalendar extends BaseTag {
  ary: any;
  init(){
    super.init();
    this.genArray();
  }
  genArray(){
    this.ary = [];
    let startYear = 2018
    let endYear = 2028
    let year = startYear;
    let month = 1
    for(let i=0; i<120; i++){
      let year = startYear + Math.floor(i / 12)
      let month = i % 12 + 1;
      this.ary.push(this.genCells(year, month))
    }
  }
  genCells(year, month){
    let cells = [];
    let start = moment(year + '-' + month + '-01');
    let last  = moment(year + '-' + month + '-01').add(4, 'month')
    // let last  = moment(year + '-' + month + '-01').add(1, 'month');
    let currentMoment = moment(year + '-' + month + '-01');
    let index = 0;
    let lastStr       = last.format('YYYY-MM-DD');
    while(currentMoment.format('YYYY-MM-DD') != lastStr){
      cells.push(new LineCalendarCell(currentMoment, index));
      currentMoment.add(1, 'days');
      index ++;
    }
    return cells;
  }
}
riot.mixin('devs.gen-calendar', GenCalendar as riot.TagMixin)
